import { render, staticRenderFns } from "./CalendarFeeds.vue?vue&type=template&id=46f02ff0"
import script from "./CalendarFeeds.vue?vue&type=script&lang=js"
export * from "./CalendarFeeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports